 
  <div class="text-end mb-3 w-100 d-flex align-items-center justify-content-between search-result-tab">
    <div class="pe-5 d-flex align-items-start flex-column align-items-xl-center flex-xl-row">
      <button
        class="bg-transparent text-blue font-12 mat-elevation-z0 float-start no-hover-bg-color line-height-25 px-3 me-5"
        mat-button mat-raised-button (click)="closeResult()">
        <mat-icon class="material-icons-outlined me-2 mat-icon-14" mat-list-icon>arrow_back_ios</mat-icon> Back to home
      </button>
      <div class="font-poppins font-14 text-start mt-3 ps-3 mt-xl-0 ps-xl-0 d-flex align-items-center">
        <div class="pe-3">You are viewing asset results for</div>
        <button class="bg-transparent ps-0 font-semibold mat-elevation-z0 no-hover-bg-color" mat-button mat-raised-button
          (click)="ViewPropertyDetails(selectedProperty?.id)">
          {{selectedProperty?.address}}
        </button>
      </div>
    </div>
    <div >
      <button class="bg-transparent text-blue font-12 mat-elevation-z0 float-end no-hover-bg-color line-height-25 px-3"
        mat-button mat-raised-button (click)="ViewPropertyDetails(selectedProperty?.id)">
        <mat-icon class="material-icons-outlined me-2 mat-icon-14" mat-list-icon>remove_red_eye</mat-icon> View property
        details
      </button>
    </div>
  </div>
  <div class="position-relative z-0">
    <mat-tab-group class="common-tabs" (selectedTabChange)="tabClicked($event)">
      <mat-tab label="To be Approved">
        <ng-template matTabContent>
           <app-asset-list-view [selectedPropertyId]="selectedProperty?.id" [assetStatus]="assetStatusCategoriesEnum.NeedToBeApproved"></app-asset-list-view>
        </ng-template>
      </mat-tab>
      <mat-tab label="Duplicated">
        <ng-template matTabContent>
          <app-asset-list-view [selectedPropertyId]="selectedProperty?.id " [assetStatus]="assetStatusCategoriesEnum.Duplicated"></app-asset-list-view>
        </ng-template>
      </mat-tab>
      <mat-tab label="Pending from Tenants">
        <ng-template matTabContent>
          <app-asset-list-view [selectedPropertyId]="selectedProperty?.id " [assetStatus]="assetStatusCategoriesEnum.SentToTenant"></app-asset-list-view>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </div>
  